import React, { FC, ReactNode } from 'react';
import classnames from 'classnames';

// @ts-ignore
import styles from './HoverDescription.scss';

const positionClassNames = {
  top: styles.top,
  bottom: styles.bottom,
};

export type HoverDescriptionType = {
  children: ReactNode;
  isHover: boolean;
  position?: 'top' | 'bottom';
  margin?: string | number;
};

export const HoverDescription: FC<HoverDescriptionType> = ({
  children,
  isHover = false,
  position = 'bottom',
  margin = '48px',
}) => {
  const style = position === 'top' ? { bottom: margin } : { top: margin };
  return (
    <div className={classnames(styles.disabledReason, isHover && styles.visible)} style={style}>
      <div className={classnames(styles.content, positionClassNames[position])}>{children}</div>
    </div>
  );
};

export type DescriptionContainerType = JSX.IntrinsicElements['div'] & {
  children: ReactNode;
  onMouseEnter: () => void;
  onMouseLeave: () => void;
};

export const DescriptionContainer: FC<DescriptionContainerType> = ({
  children,
  onMouseEnter,
  onMouseLeave,
  className,
  ...divProps
}) => {
  return (
    <div
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      className={classnames(styles.container, className)}
      {...divProps}
    >
      {children}
    </div>
  );
};
